import { render, staticRenderFns } from "./DatosLegalesCard.vue?vue&type=template&id=7287b6d7"
import script from "./DatosLegalesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosLegalesCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports